import React from "react";
import Cal from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./calender.scss";

export default function Calendar() {
    const value = new Date();
    const eventList = [
        {
            key: 1,
            title: "Demo",
            description: "Demo Description",
            date: new Date(),
            timeFrom: 12.3,
            timeTo: 13.3,
            link: null,
            type: "Class",
        },
        {
            key: 2,
            title: "Demo2",
            description: "Demo Description2",
            date: new Date(),
            timeFrom: 13.3,
            timeTo: 14.3,
            link: null,
            type: "Class",
        },
        {
            key: 3,
            title: "Demo3",
            description: "Demo Description3",
            date: new Date(),
            timeFrom: 14.3,
            timeTo: 17.3,
            link: null,
            type: "Class",
        },
    ];
    return (
        <div className="cal-wrapper">
            {/*<div className="arrow-up"></div>*/}

            <div className='axy'>
                <ul>
                    {eventList.map((item) => {
                        return <li key={item.key}>{item.title}</li>;
                    })}
                </ul>
            </div>
            <div>
                <Cal value={value} />
            </div>
        </div>
    );
}
